// Dropdown Scope
// ---------
// This dropdown is not a classic select field, yet it gives the user the option to use this like one.
// The dropdown offers a list of possible options that can be selected using the keyboard or the mouse.
// Multiple selection is not supported.
// Additional parameters can be set to initialize this component by specific values.
//
// Twig Template Path: templates/global/elements/form/dropdown_master.twig
//
// ---------
// This variables are defined in the TWIG component
// - name: string (required)
// - data: key value pair list, { key: value, key: value } (required)
// - urlParameterOn: bool
// - urlParameter: string - q_{name of field}
// - disableOnUrlParameter: bool
// - value: string
// - searchFunctionActivated: bool
//
// ---------
// This variables can not be set
// - emptyOptionsMessage: string
// - focusedOptionIndex: null
// - open: bool
// - options: array
// - search: string
// - values: array
//
// ---------
// Dropdown Supports:
// - keyboard input to filter options
// - keyboard arrow support to navigate between options
// - preselect a value by a specific ULR-Query-Parameter which starts with `q_{dropdown_name}`
//
//
document.addEventListener('alpine:init', () => {
    window.Alpine.data('dropdownMaster', (config) => ({
        name: config.name,
        data: config.data,
        type : config.type,
        delimiter: ',',
        urlParameterOn: Boolean(config.urlParameterOn) ?? false,
        urlParameter: config.urlParameter ?? '',
        disableOnUrlParameter: Boolean(config.disableOnUrlParameter) ?? false,
        value: config.value,
        emptyOptionsMessage: config.emptyOptionsMessage ?? '',
        focusedOptionIndex: null,
        open: false,
        options: {},
        search: '',
        searchOpen: config.searchOpen ?? false,
        lastFavoriteIndex: config.lastFavoriteIndex,
        searchFunctionActivated: config.searchFunctionActivated ?? true,
        multiSelectOnChangeEvent: Boolean(config.multiSelectOnChangeEvent) ?? false,
        singleSelectOnChangeEvent: Boolean(config.singleSelectOnChangeEvent) ?? false,
        dropdown: {
            ['@click.outside']() {
                this.closeListbox();
            },
            ['@keydown.escape']() {
                this.closeListbox();
                this.resetYOverflow();
            },
        },
        selectButton: {
            ['@click']() {
                this.toggleListboxVisibility();
            },
            ['@keyup.tab']() {
                this.toggleListboxVisibility();
            },
            ['@keydown.tab']() {
                this.closeListbox();
            },
            ['@keydown.arrow-up.prevent']() {
                this.focusPreviousOption();
            },
            ['@keydown.arrow-down.prevent']() {
                this.focusNextOption();
            },
            ['@keydown.enter.stop.prevent']() {
                this.setOption();
            },
        },
        placeholder: {
            ['x-show']() {
                return !this.open;
            },
            ['x-effect']() {
                /*this.$refs.placeholder.innerHTML = (this.value in this.options) ? (this.showValueAsText ? this.value : this.options[this.value]) : this.placeholder;*/
                //this.setPlaceholderText(this.value);
            },
        },
        validateIcon: {},
        toggleListIcon: {},
        tagCounter: {
            ['x-effect']() {
                /*  ToDo: check the input or placeholder container length and set the tag only if the max-width is reached. */
                /*
                console.info(this.$refs.placeholder.offsetWidth);
                console.info(this.$refs.placeholder.scrollWidth);
                console.info(this.$refs.placeholder.offsetWidth < this.$refs.placeholder.scrollWidth);
                */
                this.$refs.tagCounter.innerHTML = Object.keys(this.value).length;
            },
        },
        dropdownList: {
            ['x-show']() {
                this.open = true;
            },
            ['@click.outside']() {
                this.open = false;
            },
        },
        searchField: {
            ['x-show']() {
                return this.searchOpen;
            },
        },
        menuOptionsWrapper: {
            ['x-show']() {
                return this.open;
            },
        },
        menuOptions: {
            ['@click.outside']() {
                this.open = false;
                this.resetYOverflow()
            },
        },
        selectOption: {
            ['@click']() {
                this.setOption();
                this.resetYOverflowOnSingleSelect()
            },
        },
        selectAllItem: {
            ['@click']() {
                this.value = Object.assign({}, this.options);
                this.setPlaceholderText(this.options);
                this.focusedOptionIndex = null;
                this.closeListbox();
                this.updateUrlParameter();
                this.multiSelectChanges();
            }
        },
        resetItem: {
            ['@click']() {
                this.value = {};
                this.search = '';
                this.focusedOptionIndex = null;
                this.setPlaceholderText('');
                this.updateUrlParameter();
                this.multiSelectChanges();
            }
        },
        searchItem: {
            ['@click'](event) {
                this.searchOpen = !this.searchOpen;
                this.$nextTick(() => {
                    if (this.searchOpen) {
                        this.$refs.search.focus();
                    }
                });
            }
        },
        emptyOptionMessageBox: {
            ['x-show']() {
                if (!this.options.length)
                    return true;
            },
            ['x-text']() {
                return this.emptyOptionsMessage;
            }
        },
        init() {
            this.options = this.data;

            /* Set placeholder if they are already predefined */
            this.setPlaceholderText();

            this.$watch('value', () => {
                /* Manually trigger change event for hidden input field so bxValidate can validate it's value again */
                let hiddenInputDropdown = document.querySelector('[name=' + this.name + ']');
                hiddenInputDropdown.dispatchEvent(new Event('change'));

                this.setPlaceholderText();
            });

            // search function and watcher
            if(this.searchFunctionActivated) {
                this.$watch('search', ((value) => {
                    if (!this.open || !value) {
                         return this.options = this.data;
                    }
                    this.options = Object.keys(this.data)
                        .filter((key) => this.data[key].toLowerCase().includes(value.toLowerCase()))
                        .reduce((options, key) => {
                            options[key] = this.data[key];
                            return options;
                        }, {})
                }))
            }

            if (this.urlParameterOn) {
                this.$watch('urlParameter', (value) => {
                    const url = new URL(window.location.href);

                    if (value === '' || (Array.isArray(value) && !value.length)) {
                        url.searchParams.delete('q_' + this.name);
                    } else {
                        url.searchParams.set('q_' + this.name, value);
                    }
                    history.pushState(null, document.title, url.toString());
                })
            }

            // Url parameter handling
            this.urlParameterBehaviour();

            /* If a defaultValue is set we have to add changes to the dropdown field */
            if (typeof this.value !== 'object' && this.value.length) {
                this.$el.classList.add('is-focused');
            }

            // set correct background label color
            window.domUtils.setBackgroundColor(this.$el);
        },
        closeListbox() {
            if (Object.keys(this.value).length !== 0) {
                this.$refs.dropdown.classList.add('is-focused');
            } else {
                this.$refs.dropdown.classList.remove('is-focused');
            }

            this.open = false;
            this.focusedOptionIndex = null;
            this.search = '';
        },
        focusNextOption() {
            if (this.focusedOptionIndex === null) {
                return this.focusedOptionIndex = Object.keys(this.options).length - 1;
            }

            if (this.focusedOptionIndex + 1 >= Object.keys(this.options).length) {
                return '';
            }

            this.focusedOptionIndex++;
            this.$refs.ul.children[this.focusedOptionIndex].scrollIntoView({block: "center"});
        },
        focusPreviousOption() {
            if (this.focusedOptionIndex === null) {
                return this.focusedOptionIndex = 0;
            }

            if (this.focusedOptionIndex <= 0) {
                return;
            }

            this.focusedOptionIndex--;
            this.$refs.ul.children[this.focusedOptionIndex].scrollIntoView({block: "center"});
        },
        setOption() {
            if (!this.open) {
                return this.toggleListboxVisibility();
            }

            /** SingleSelect
             *  ============
             *  - this.focusedOptionIndex can be type of Number or String
             *      - Number is used if this.options is a simple array (example: phone_prefix | ['+41','+49'])
             *      - String is used if this.options is a object (example: legal_form | { foundation: 'foundation'|t  } )
             */
            if (typeof this.value !== 'object') {

                /** If this.options is typeOf 'object' && this.focusedOptionIndex is typeOf 'string'
                 *  ================================================================================
                 *  Than we have the object structure for this.options
                */

                if (typeof this.options === 'object' && !Number.isInteger(Number.parseInt(this.focusedOptionIndex))) {
                    /* Check if this.focusedOptionIndex is a number */

                    this.value = this.getKeyByValue(this.options, this.options[this.focusedOptionIndex]);
                }
                /** If this.options is not typeOf 'object' && this.focusedOptionIndex is typeOf 'int'
                 *  ================================================================================
                 *  Than we have the array structure for this.options
                 */
                else {
                    this.value = this.focusedOptionIndex;
                }

                if (this.singleSelectOnChangeEvent) {
                    window.dispatchEvent(new CustomEvent('single-select-on-change', {
                        detail: {
                            fieldName: this.name,
                            value: this.value,
                        }
                    }));
                }

                this.closeListbox();
            }

            /** MultiSelect
             *  ===========
             *  This case is used if this.value is type of array
             */
            else if (typeof this.value === 'object') {

                if (Object.keys(this.value).includes(this.focusedOptionIndex)) {
                    delete this.value[this.focusedOptionIndex];
                } else {
                    this.value[this.focusedOptionIndex] = this.options[this.focusedOptionIndex];
                }

            }

            /* Add URL Parameter*/
            this.updateUrlParameter();
            this.multiSelectChanges();
        },
        getKeyByValue(object, value) {
            let match = Object.keys(object).filter(key => object[key] === value);
            return (match) ? match[0] : false;
        },
        // CR-4365
        calculateMaxWidthOfListItems() {
            let positionOfList = this.$refs.dropdown.getBoundingClientRect();
            let wrapper = document.getElementById('wrapper');
            let menuOptions = this.$refs.dropdown.querySelector('.menuOptions');
            let totalHorizontalPadding = parseFloat(window.getComputedStyle(menuOptions).paddingLeft) + parseFloat(window.getComputedStyle(menuOptions).paddingRight);

            if (wrapper) {
                let widthOfListItems = wrapper.offsetWidth - positionOfList.x;
                // get all list items from ul
                let listItems = this.$refs.dropdown.querySelectorAll('li');
                listItems.forEach((item) => {
                    item.style.maxWidth = (widthOfListItems - totalHorizontalPadding) + 'px';
                    let span = item.querySelector('span');
                    if (span) {
                        span.classList.add('inline-block');
                    }
                });
            }
        },

        toggleListboxVisibility() {
            if (this.open) {
                return this.closeListbox();
            }
            this.setOverflowYToInitial();
            if (Object.keys(this.value).length !== 0) {
                this.$refs.dropdown.classList.add('is-focused');
            }

            /* Variable need for scrollIntoView */
            if (!Array.isArray(this.options) && !Number.isInteger(Number.parseInt(this.focusedOptionIndex)) && this.focusedOptionIndex !== null) {
                /* If object */
                if (this.options.hasOwnProperty(this.value)) {
                    this.focusedOptionIndex = this.getKeyByValue(this.options, this.value);
                }
                else {
                    this.focusedOptionIndex = this.options.indexOf(this.value);
                }
            } else if (Array.isArray(this.options)) {
                this.focusedOptionIndex = this.options.indexOf(this.value);
            }

            if (this.focusedOptionIndex < 0 || this.focusedOptionIndex == null) {
                this.focusedOptionIndex = 0;
            }

            /* Open menu */
            this.open = true;

            this.$nextTick(() => {
                setTimeout(() => {
                    if (typeof (this.$refs.search) != 'undefined') {
                        this.$refs.search.focus();
                    }
                    this.$refs.ul.children[this.focusedOptionIndex].scrollIntoView({block: "center"});
                    this.calculateMaxWidthOfListItems();
                }, 50);
            })
        },
        applyDisabledOnUrlParameter: function () {
            /* Change cursor-pointer to cursor-not-allowed to disable the select-option possibility */
            this.$refs.button.style.cursor = 'not-allowed';
            this.$refs.button.style.border = '';
            this.$refs.button.style.outline = '';
            this.$refs.button.style.borderWidth = '1px';

            this.$refs.button.removeAttribute('x-bind');
            this.$refs.toggleListIcon.classList.add('hidden');

            if (this.$refs.validateIcon !== undefined) {
                this.$refs.validateIcon.classList.add('hidden');
            }
        },
        urlParameterBehaviour() {
            // set Label by URL parameter
            if (this.urlParameterOn && this.urlParameter.length > 0) {
                let labelSet = false;

                switch(this.type) {
                    case 'single-select':
                        labelSet = this.setLabelValueFromUrlParameterSingleSelect();
                        break;
                    case 'multi-select':
                        labelSet = this.setLabelValueFromUrlParameterMultiSelect();
                        break;
                    default:
                        console.error('DropdownMaster: Type is not defined: ', this.type);
                }

                /* Set is-focused css class */
                this.$el.classList.add('is-focused');

                (labelSet && this.disableOnUrlParameter) ? this.applyDisabledOnUrlParameter() : null;
            }
        },
        updateUrlParameter() {
            if (this.urlParameterOn) {
                switch (this.type){
                    case 'multi-select':
                        this.updateMultiUrlParameter();
                        break;
                    case 'single-select':
                        this.updateSingleUrlParameter();
                        break;
                    default:
                        console.error('DropdownMaster: Type is not defined: ', this.type);
                }
            }
        },
        updateSingleUrlParameter() {
            this.urlParameter = this.value;
        },
        updateMultiUrlParameter() {
            this.urlParameter = Object.keys(this.value).join(this.delimiter + ' ');
        },
        setPlaceholderText() {

            if(this.value){
                switch (typeof this.value) {
                    case 'string':
                        if (this.value in this.options) {
                            this.$refs.placeholder.innerHTML = this.options[this.value];
                        }
                        break;
                    case 'object':
                        const keys = Object.values(this.value).join(this.delimiter + ' ');
                        this.$refs.placeholder.innerHTML = keys;
                        if (keys.length === 0){
                            this.$el.classList.remove('is-focused');
                        } else {
                            this.$el.classList.add('is-focused');
                            let display = window.getComputedStyle(this.$refs.placeholder, null).display;
                            if (display === 'none') {
                                // set display to block
                                this.$refs.placeholder.style.display = 'block';
                            }
                        }

                        break;
                    default:
                        this.$refs.placeholder.innerHTML = '';
                }
            } else {
                this.$refs.placeholder.innerHTML = '';
            }
        },
        setLabelValueFromUrlParameterSingleSelect() {
            if (this.urlParameter in this.options) {
                this.value = this.urlParameter;
                return true;
            } else {
                return false;
            }
        },
        setLabelValueFromUrlParameterMultiSelect() {
            /* Get strings from URL which are the KEY values and save them as array */
            let urlValues = this.urlParameter.split(this.delimiter);

            /* Check if single values are part of options and push them to value */
            urlValues.forEach(v => {
                /* Cleanup value and remove whitespaces "before" & "after" the string */
                let trimValue = v.trimStart().trimEnd()

                if (Object.keys(this.options).indexOf(trimValue) !== -1) {
                    this.value[trimValue] = this.options[trimValue];
                }
            })
            // TODO: Implement
            // We checked if values are present. We need further define what happens if values are not present.
            // We also have to define what happens if SOME values are not present.
            // console.warn('not implemented completely');
            return true;
        },
        setOverflowYToInitial() {
            if(window.innerWidth < 1024) {
                const backdrop = document.querySelector('.modal #backdrop');
                backdrop.style.setProperty('overflow-y', 'initial');
            }
        },
        resetYOverflow(){
            this.$nextTick(() => {
                const backdrop = document.querySelector('.modal #backdrop');
                backdrop.style.removeProperty('overflow-y');
            });
        },
        resetYOverflowOnSingleSelect(){
            if (this.type === 'single-select'){
                this.resetYOverflow();
            }
        },
        multiSelectChanges() {
            if (this.multiSelectOnChangeEvent) {
                window.dispatchEvent(new CustomEvent('multi-select-on-change', {
                    detail: {
                        fieldName: this.name,
                        values: this.value,
                    }
                }));
            }
        },
    }))
})


/*
    Todo: Finish feature and add a new class to do differences between open submenu top or bottom
    Helper for dropdown to show the submenu at top or bottom
    depends on screen height
*/
/*
let dropdownCollection = document.getElementsByClassName("dropdown-master");
Array.from(dropdownCollection).forEach(item => {
    if (window.innerHeight - item.getBoundingClientRect().bottom < item.scrollHeight){
        item.classList.add('top');
    } else {
        item.classList.add('bottom');
    }
});
*/
